export default __webpack_public_path__ + "static/media/player-login.cd4cd05a.svg";